import { Paper } from '@mui/material'
import { SxProps } from '@mui/system'
import { ReactNode } from 'react'
import COLORS from '../styles/colors'

export type RoundedPaperProps = {
  children: ReactNode

  sx?: SxProps
}

const RoundedPaper = ({ children, sx }: RoundedPaperProps) => {
  return (
    <Paper
      sx={{
        mt: 0,
        padding: ['10px', '20px', '40px'],
        backgroundColor: COLORS.white,
        border: `1px solid ${COLORS.borderGrey}`,
        boxShadow: '2px 2px 2px rgba(0,0,0,0.04)',
        borderRadius: '8px',
        ...sx,
      }}
    >
      {children}
    </Paper>
  )
}

export default RoundedPaper
